<template>
  <ValidationProvider
    :rules="validate || ''"
    v-slot="v"
  >
    <div
      class="form-group"
      :class="{'has-warning':  v.errors[0] !== ''}"
    >
      <div :class="{'form-group row': inline}">
        <div :class="{'col-sm-2 mt-1': inline}">
          <label
            v-if="label"
            :for="name"
            class="control-label"
          >
            {{label}}:
            <span
              class="text-danger"
              v-if="hasAsterisk"
            >*</span>
          </label>
        </div>
        <div :class="{'col-sm-10': inline}">
          <textarea
            :id="name"
            class="form-control"
            :rows="rows || 2"
            :name="name"
            :value="value || ''"
            @keyup="keyup"
            @input="change"
            :maxlength="maxlength || 500"
            :placeholder="placeholder"
            :readonly="readonly"
            :disabled="disabled"
            :tabindex="tabindex"
          />
          <small class="text-danger" v-if="v.errors[0] !== ''">
          {{ v.errors[0] }}
        </small>
      </div>
    </div>
  </div>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'dt-textarea',
  props: {
    name: String,
    value: String,
    label: String,
    validate: String,
    disabled: Boolean,
    maxlength: Number,
    readonly: Boolean,
    placeholder: String,
    rows: [Number, String],
    inline: {
      type: Boolean,
      default: false
    },
    tabindex: [Number, String]
  },
  computed: {
    hasAsterisk() {
      return this.validate && this.validate.includes('required')
    }
  },
  methods: {
    change($event) {
      this.$emit('input', $event.target.value)
    },
    keyup($event) {
      this.$emit('keyup', $event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-textarea.vue